const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_ENDPOINT = "/user_flag_group";
const USER_FLAG_GROUP = "MonitoringTest";
const USER_FLAG_ACTIONS = {
  update: "update",
  remove: "remove"
};
const PAYMENT_PROVIDERS = {
  "pagarme": "PSP 1.0",
  "pagarme_v5": "PSP 2.0",
  "jussub": "JusSub",
  "jus_sub": "JusSub"
};

export {
  BASE_ENDPOINT, BASE_URL, USER_FLAG_ACTIONS, USER_FLAG_GROUP, PAYMENT_PROVIDERS
};
